<template>
  <div class="chat__body" id="chat__body">
    <chat-message v-for="(item, index) in msgs" :userId="userId" :key="index" :msg="item">
    </chat-message>
  </div>
</template>

<script>
import ChatMessage from "./ChatMessage";

export default {
  components: {
    ChatMessage,
  },
  props: ["msgs", "userId"],
};
</script>

<style>
.chat__body {
  padding: 0.5rem;
  overflow: scroll;
  scroll-behavior: smooth;
}

.chat__body::-webkit-scrollbar {
  display: none;
}
</style>